const scrollState = {
    scrollTracker: 0
};

const getScrollTrackerState = () => scrollState;

const changeScrollTracker = (value) => {
    scrollState.scrollTracker = value;
};

module.exports = {
    getScrollTrackerState: getScrollTrackerState,
    changeScrollTracker: changeScrollTracker,
};
